import { Modal } from "antd";
import { useEffect, useState } from "react";
import { useUser } from "../../screens/user/context.js/userContext";

const SuccessPaidModal = ({ merchantId }) => {
    const { returnUrl, showSuccess } = useUser()
    const [loading, setLoading] = useState(false)
    useEffect(() => {
        if (showSuccess) {
            if (merchantId === 1) return done()
            setLoading(true)
            setInterval(() => {
                setLoading(false)
                done()
            }, 2000);
        }
    }, [showSuccess])
    const done = () => {
        window.location.href = returnUrl
    }

    return (
        <Modal title={``} open={showSuccess} cancelButtonProps={{ style: { display: 'none' } }} closable={false} onCancel={null} footer={null}>
            <div className="successPaidContainer">
                <div class="checkmark-container">
                    <div class="checkmark-circle">
                        <div class="checkmark"></div>
                    </div>
                </div>

                <h1 className="success-title">Баяр хүргье!</h1>
                <p className="success-message">Амжилттай төлөгдлөө</p>
                <div className={`bottom-border ${loading ? "loading" : ""}`}></div>

            </div>
        </Modal>
    );
}

export default SuccessPaidModal;